<template>
  <div class="layouts">
    <div class="container">
      <div class="header">
        <div>
          <span>搜尋</span>
        </div>
      </div>
      <div class="search">
        <div class="search_bar_root">
          <input
            id="search_input"
            placeholder="搜尋樓盤名稱"
            type="text"
            v-model="search"
          >
          <button class="ui button">
            <span>
              <img
                src="@/assets/web_icons/search_icon.png"
                alt=""
              >
            </span>
          </button>
        </div>
      </div>
      <div class="districts">
        <div
          v-for="v in mainDistricts"
          v-bind:key="v"
          class="district"
        >
          <div class="title">
            <span>{{v}}</span>
          </div>
          <div class="layouts_container">
            <div
              v-for="vv in getDistrictLayouts(v)"
              v-bind:key="vv._id"
              class="layout_container"
            >
              <LayoutCard v-bind:data="vv"></LayoutCard>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.layouts {
  background-color: white;
  .container {
    max-width: 1820px;
    box-sizing: border-box;
    position: relative;
    width: 95%;
    padding: 16px 20px 10px;
    margin: auto auto 20px;
    .header {
      padding: 0;
      text-align: left;
      > div {
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 15px;
        margin-left: 15px;
        line-height: 50px;
        > span {
        }
      }
    }
    .search {
      .search_bar_root {
        transition: all 0.2s ease;
        width: 100%;
        margin-bottom: 50px;
        position: relative;
        font-weight: 400;
        font-style: normal;
        display: inline-flex;
        color: rgba(0, 0, 0, 0.87);
        font-size: 1em;
        input#search_input {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
          border-right-color: transparent !important;
          margin: 0;
          max-width: 100%;
          flex: 1 0 auto;
          outline: 0;
          text-align: left;
          padding: 0.67857143em 1em;
          color: rgba(0, 0, 0, 0.87);
          transition: box-shadow 0.1s ease, border-color 0.1s ease;
          box-shadow: none;
          background: #f5f5f5 !important;
          border: none !important;
          border-radius: 0 !important;
          line-height: 30px !important;
          font-size: 15px;
          appearance: none;
        }
        button {
          align-items: center;
          flex: 0 0 auto;
          cursor: pointer;
          display: inline-block;
          min-height: 1em;
          outline: 0;
          border: none;
          vertical-align: baseline;
          margin: 0 0.25em 0 0;
          text-transform: none;
          text-shadow: none;
          font-weight: 700;
          line-height: 1em;
          font-style: normal;
          text-align: center;
          text-decoration: none;
          box-shadow: 0 0 0 1px transparent inset,
            0 0 0 0 rgba(34, 36, 38, 0.15) inset;
          user-select: none;
          transition: opacity 0.1s ease, background-color 0.1s ease,
            color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease,
            -webkit-box-shadow 0.1s ease;
          will-change: "";
          -webkit-tap-highlight-color: transparent;
          background: #f5f5f5 !important;
          color: #5f6368;
          border-radius: 0 !important;
          padding: 0 30px !important;
          font-size: 15px !important;
          appearance: button;
          > span {
            > img {
              height: 1em;
            }
          }
        }
      }
    }
    .districts {
      > .district {
        padding: 0;
        text-align: left;
        > div.title {
          font-size: 30px;
          font-weight: 700;
          margin: 0 0 15px;
          padding-left: 8px;
          line-height: 50px;
          background-color: #f0eff4;
          > span {
          }
        }
        > div.layouts_container {
          display: flex;
          flex-wrap: wrap;
          > div {
            display: flex;
            justify-content: center;
            margin-bottom: 1rem;
            @media all and (min-width: 1321px) {
              width: calc(100% / 6 - 0.01px);
            }
            @media all and (min-width: 901px) and (max-width: 1320px) {
              width: calc(100% / 4 - 0.01px);
            }
            @media all and (min-width: 396px) and (max-width: 900px) {
              width: calc(100% / 2 - 0.01px);
            }
            @media all and (max-width: 395px) {
              width: calc(100% / 1 - 0.01px);
            }
            box-sizing: border-box;
            padding: 8px 8px 12px 8px;
          }
        }
      }
    }
  }
}
</style>

<script>
// @ is an alias to /src
import LayoutCard from "@/components/LayoutCard.vue";
import axios from "axios";
import _ from "lodash";

export default {
  name: "layouts",
  components: {
    LayoutCard
  },
  data() {
    return {
      search: "",
      layouts: {},
      layoutsArr: [],
      mainDistricts: ["澳門", "氹仔", "路環", "其他"]
    };
  },
  computed: {
    // filteredList() {}
  },
  methods: {
    getDistrictLayouts(d) {
      if (!this.search) {
        return this.layouts[d] || [];
      } else {
        const filteredList = this.layouts[d].filter(a =>
          a.name.includes(this.search)
        );
        return filteredList;
      }
    }
  },
  mounted() {
    axios
      .get("https://api.topagentmo.com/api/buildings/layouts")
      .then(res => res.data)
      .then(d => {
        this.layoutsArr = d;
        this.layouts = _.groupBy(
          d,
          v =>
            this.mainDistricts.filter(md => v.district.startsWith(md))[0] ||
            "其他"
        );
      })
      .catch(e => null);
  }
};
</script>
